@if (paused()) {
  <app-platform-jobs-empty-state
    [icon]="icons.sparkles"
    [title]="'jobboard.platform.recommendations.paused-title' | transloco"
    [text]="'jobboard.platform.recommendations.paused-text' | transloco"
    [ctaLabel]="'jobboard.platform.recommendations.paused-cta' | transloco"
    [ctaIcon]="icons.gear"
    [ctaLink]="['/settings']"
    [secondaryCtaLabel]="'jobboard.platform.sidenav.leave' | transloco"
    [secondaryCtaIcon]="icons.switch"
    [secondaryCtaLink]="['/']"
  />
} @else if (jobs().length === 0) {
  <app-platform-jobs-empty-state
    [icon]="icons.sparkles"
    [title]="'jobboard.platform.recommendations.empty-title' | transloco"
    [text]="'jobboard.platform.recommendations.empty-text' | transloco"
    [ctaLabel]="'jobboard.platform.recommendations.empty-cta' | transloco"
    [ctaIcon]="icons.user"
    [ctaLink]="['/profile']"
    [secondaryCtaLabel]="'jobboard.platform.sidenav.leave' | transloco"
    [secondaryCtaIcon]="icons.switch"
    [secondaryCtaLink]="['/']"
  />
} @else {
  <div class="table-wrapper">
    <p-table
      [value]="jobs()"
      dataKey="id"
      [rowTrackBy]="trackById"
      sortField="score"
      [sortOrder]="-1"
      [scrollable]="true"
      [scrollHeight]="'flex'"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="jobTitle">
            {{ 'jobboard.platform.jobs.table.job' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th pSortableColumn="companyName">
            {{ 'jobboard.platform.jobs.table.company' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th class="d-none d-md-table-cell" pSortableColumn="location">
            {{ 'jobboard.platform.jobs.table.location' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th class="d-none d-lg-table-cell" pSortableColumn="score">
            {{ 'jobboard.platform.jobs.table.match' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th class="actions">{{ 'jobboard.platform.jobs.table.actions' | transloco }}</th>
        </tr>
      </ng-template>
      <ng-template #body let-job>
        <tr>
          <td>
            <div class="cell-job">
              @if (jobsService.jobboardJobUrl(job.companyId, job.id); as jobUrl) {
                <a
                  [href]="jobUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{ job.jobTitle }}</a>
              } @else {
                <span>{{ job.jobTitle }}</span>
              }
              @if (job.invited) {
                <ct-lib-tag [variant]="TagVariant.DEFAULT">
                  {{ 'jobboard.platform.recommendations.invited-tag' | transloco }}
                </ct-lib-tag>
              }
            </div>
          </td>
          <td>
            <div class="cell-company">
              @if (jobsService.jobboardCompanyUrl(job.companyId); as companyUrl) {
                <a
                  [href]="companyUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  [attr.aria-label]="'jobboard.platform.jobs.open-company' | transloco"
                >
                  <app-platform-company-logo [companyName]="job.companyName" [companyId]="job.companyId" [small]="true" />
                  <span>{{ job.companyName }}</span>
                </a>
              } @else {
                <app-platform-company-logo [companyName]="job.companyName" [companyId]="job.companyId" [small]="true" />
                <span>{{ job.companyName }}</span>
              }
            </div>
          </td>
          <td class="d-none d-md-table-cell">
            {{ job.location }}@if (job.workingModel) { ({{ workingModelLabelKey(job) | transloco }}) }
          </td>
          <td class="d-none d-lg-table-cell">
            @if (job.score != null) {
              <ct-lib-score-chip
                [score]="job.score ?? undefined"
                [label]="scoreLabelKey(job) | transloco"
                [showChevron]="false"
                [small]="true"
              />
            }
          </td>
          <td class="actions">
            @if (job.open) {
              <app-platform-job-apply-menu
                [applied]="jobsService.hasAppliedToBoardJob(job)"
                [context]="jobsService.applyContextFromBoardJob(job)"
              />
            }
            <app-platform-job-bookmark-button
              [payload]="jobsService.bookmarkPayloadFromBoardJob(job)"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
